import { toast } from "../../../components/toastNotification";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/Role";

export const getRolesWithUsers = async () => {
  const res = await axios.get(`${api_base_url}/RolesWithUsers`);
  return res.data;
};
export const getRolesPermissions = async (userId) => {
  return await axios
    .get(`${api_base_url}/RolePermissionByRoleId/${userId}`)
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        toast.fire(
          "Warning",
          "Cannot Retrieve Permissions, please check connection or contact your admin",
          "error"
        );
        return [];
      }
    });
};
export const updateFranchiseUserStatus = (userId, status, userType) => {
  return axios
    .post(`${api_base_url}/updateFranchiseUserStatus`, {
      userId,
      status,
      userType,
    })
    .then((res) => {
      return res.data;
    });
};

export const deleteModulePermission = (id) => {
  return axios.delete(`${api_base_url}/DeleteModulePermission`, {
    params: {
      RoleId: id,
    },
  });
};

export const updateUserPermission = async (permissions) => {
  return axios
    .post(
      `${api_base_url}/ModuleManagement/UpdateRolePermissions/`,
      permissions
    )
    .then((res) => {
      if (res.status === 400) {
        res.json();
      }
      return res.permissions;
    });
};
